import { Divider, Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface DocumentFormatFooterProps {
  footerText?: string;
}

export function DocumentFormatFooter({ footerText }: DocumentFormatFooterProps): JSX.Element | null {
  if (!footerText) return null;
  return (
    <>
      <Divider />
      <Text size="xs" c="dimmed" ta="center" style={{ whiteSpace: 'pre-line' }}>
        {footerText}
      </Text>
    </>
  );
}

interface DocumentFormatShellProps {
  footerText?: string;
  children: ReactNode;
}

/** Wraps document content with the resolved footer below the body. */
export function DocumentFormatShell({
  footerText,
  children,
}: DocumentFormatShellProps): JSX.Element {
  return (
    <Stack gap="md">
      {children}
      <DocumentFormatFooter footerText={footerText} />
    </Stack>
  );
}
